import { render, staticRenderFns } from "./DigitalReceipt.vue?vue&type=template&id=7cc4ee8a&"
import script from "./DigitalReceipt.vue?vue&type=script&lang=js&"
export * from "./DigitalReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports